module.exports = {"430802001":"永定街道","430802002":"大庸桥街道","430802003":"西溪坪街道","430802004":"官黎坪街道","430802005":"崇文街道","430802006":"南庄坪街道","430802100":"新桥镇","430802101":"茅岩河镇","430802102":"教字垭镇","430802103":"天门山镇","430802104":"沅古坪镇","430802105":"尹家溪镇","430802108":"王家坪镇","430802201":"三家馆乡","430802204":"合作桥乡","430802206":"谢家垭乡","430802208":"罗塔坪乡","430802209":"罗水乡","430802210":"桥头乡","430802212":"四都坪乡","430802404":"原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430802.json
// module id = 1717
// module chunks = 0